import useElysiaStore from '@/app/elysia-store';
import notify from '@/services/notify';

const EXTENSION_BY_MIME: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
};

export const handleInvalidData = (val) => {
  return val === undefined || val === 'nan' ? '' : val;
};

export const checkForDuplicateFiles = (files: File[]): File[] => {
  const existingFiles = useElysiaStore.getState().attachedFileArray || [];
  const existingNames = new Set(existingFiles.map((f) => f.name));

  const duplicates = files.filter((file) => existingNames.has(file.name));

  duplicates.forEach((file) => {
    notify({
      message: `Your file "${file.name}" already exists and is currently being processed. If the file has been modified, please change the filename and upload it again.`,
      type: 'error',
      autoClose: false,
    });
  });

  return duplicates;
};

const GENERIC_PASTED_NAME_PATTERN =
  /^(image|img|screenshot|clipboard|capture|unnamed)\.[a-z0-9]+$/i;

export const getUniquePastedFileName = (file: File, existingNames: Set<string>): string => {
  const ext = EXTENSION_BY_MIME[file.type] ?? 'png';
  const trimmedName = file.name?.trim() ?? '';

  const isGeneric = trimmedName.length === 0 || GENERIC_PASTED_NAME_PATTERN.test(trimmedName);

  let candidate = isGeneric ? `image-${Date.now()}.${ext}` : trimmedName;

  if (existingNames.has(candidate)) {
    const base = candidate.replace(/\.[^/.]+$/, '');
    candidate = `${base}-${Date.now()}.${ext}`;
  }

  return candidate;
};
